module.exports = __webpack_public_path__ + "img/9791159318115.40c294bb.jpg";